import request from '@/utils/request';

// 1. 获取商店应用分类列表
export function fetchStoreAppClassificationList(params = { disableTree: false }) {
  return request({
    url: `/app-server/markets/${params.marketID}/classifications`,
    method: 'get',
    params: {
      disableTree: params.disableTree
    }
  });
}

// 2. 添加应用分类
export function addStoreAppClassification(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/classifications`,
    method: 'post',
    data: data
  });
}
// 3. 修改应用分类
export function upDateStoreAppClassificationInfo(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/classifications/${data.appClassificationID}`,
    method: 'PUT',
    data
  });
}

// 4. 删除应用分类
export function deleteStoreAppClassification(data) {
  return request({
    url: `/app-server/markets/${data.marketID}/classifications/${data.appClassificationID}`,
    method: 'DELETE'
  });
}



// WEBPACK FOOTER //
// ./src/api/appClassification.js